import { Injectable } from '@angular/core';
import {lastValueFrom, Observable, of} from 'rxjs';

import { catchError, map, take } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TransactionService {
  constructor(private httpClient: HttpClient) {}

  search(payload: any): Promise<any> {
    return lastValueFrom(
      this.httpClient
        .post(`${environment.apiUrl}/transaction/search`, payload)
        .pipe(map((data) => data))
    );
  }

  searchUser(payload: any): Promise<any> {
    return lastValueFrom(
      this.httpClient
        .post(`${environment.apiUrl}/transaction/searchUser`, payload)
        .pipe(map((data) => data))
    );
  }

  exportExcelAdmin(payload: any): Promise<any> {
    return lastValueFrom(
      this.httpClient
        .post(`${environment.apiUrl}/transaction/exportExcelAdmin`, payload,
          { responseType: 'arraybuffer' })
        .pipe(map((data) => data))
    );
  }

  exportExcelUser(payload: any): Promise<any> {
    return lastValueFrom(
      this.httpClient
        .post(`${environment.apiUrl}/transaction/exportExcelUser`, payload,
          { responseType: 'arraybuffer' })
        .pipe(map((data) => data))
    );
  }

  downloadPdf(docNo: string): void {
    this.httpClient
      .get(`${environment.apiUrl}/reports/exportPdf?docNo=${docNo}`, { responseType: 'blob' })
      .subscribe({
        next: (blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `transaction_${docNo}.pdf`;
          a.click();
          window.URL.revokeObjectURL(url);
        }
      });
  }

  downloadPdfGroup(payload: any): void {
    this.httpClient
      .post(`${environment.apiUrl}/reports/exportPdfGroup`, payload, { responseType: 'blob' })
      .subscribe(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `transaction_${payload.vendorId}.pdf`;
        a.click();
        window.URL.revokeObjectURL(url);
      });
  }

  downloadPdfAdmin(payload: any): void {
    this.httpClient
      .post(`${environment.apiUrl}/reports/exportPdfAdmin`, payload, { responseType: 'blob' })
      .subscribe(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `transaction_${new Date().getTime()}.pdf`;
        a.click();
        window.URL.revokeObjectURL(url);
      });
  }

  downloadPdfUser(payload: any): void {
    this.httpClient
      .post(`${environment.apiUrl}/reports/exportPdfUser`, payload, { responseType: 'blob' })
      .subscribe(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `transaction_${new Date().getTime()}.pdf`;
        a.click();
        window.URL.revokeObjectURL(url);
      });
  }
}
